/** True when only viewport height changed (mobile browser chrome / soft keyboard). */
export const isViewportChromeResize = (
    prevWidth: number,
    prevHeight: number,
    width: number,
    height: number,
): boolean => width === prevWidth && height !== prevHeight;
